import { Injectable } from '@angular/core';
import { InMemoryHttpClient } from './in-memory-http-client';
import { Observable } from 'rxjs';
import { RequestInfo, ResponseOptions, STATUS } from 'angular-in-memory-web-api';
import { AssignStoresToUserRequest } from '../../../interfaces/request/UserRequests';

/**
 * This service intercepts {@link UserService} requests and redirects them to an in-memory data store.
 */
@Injectable({
  providedIn: 'root'
})
export class InMemoryUsersDataService implements InMemoryHttpClient {

  /** Users test data. */
  users = [
    { email: 'user1', stores: ['12', '27', '81', '85'] },
    { email: 'user2', stores: ['A4'] },
    { email: 'user3', stores: ['B1', 'B6'] },
    { email: 'user4', stores: ['C3', 'C4', 'C5', 'C7', 'C8'] }
  ];

  /**
   * Intercepts HTTP DELETE request of {@link UserService}.
   * @param reqInfo information about the current HTTP DELETE request.
   */
  delete(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP GET request of {@link UserService}. Gets all required records from an in-memory data store.
   * @param reqInfo information about the current HTTP GET request.
   */
  get(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
        return {
          body: this.users,
          status: STATUS.OK
        };
      }
    );
  }

  /**
   * Intercepts HTTP POST request of {@link UserService}.
   * @param reqInfo information about the current HTTP POST request.
   */
  post(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PUT request of {@link UserService}.
   * @param reqInfo information about the current HTTP PUT request.
   */
  put(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return undefined;
  }

  /**
   * Intercepts HTTP PATCH request of {@link UserService}. Updates a record in in-memory data store.
   * @param reqInfo information about the current HTTP PATCH request.
   */
  patch(reqInfo: RequestInfo): Observable<ResponseOptions> {
    return reqInfo.utils.createResponse$(() => {
      const id = reqInfo.req.url.split('users/')[1].split('/')[0];
      const requestBody = reqInfo.utils.getJsonBody(reqInfo.req);
      return this.assignStores(id, requestBody);
    });
  }

  private assignStores(email: string, request: AssignStoresToUserRequest): ResponseOptions {
    const foundUser = this.users.find(user => user.email === email);
    foundUser.stores = request.stores;

    return {
      status: STATUS.OK
    };
  }
}
